'use strict';

import React from 'react';
import {Flux} from 'fluxxor';
import $ from 'jquery';
import Immutable from 'immutable';
import attachFastClick from 'fastclick';
import Cookies from 'js-cookie';

import LayerStack from 'ofs/components/layers/LayerStack';
import Keyboard from 'ofs/utils/keyboard';
import legacy from 'ofs/legacy-components';
import initLegacyHeader from 'ofs/components/header';

import LanguageWarning from 'ofs/react/components/LanguageWarning';

import actions from './base-actions';

import DateStore from './stores/date';
import EnquiryStore from './stores/enquiry';
import GuestStore from './stores/guest';
import LayerStore from './stores/layers';
import TrackingStore from './stores/tracking';
import LanguageStore from './stores/language';

import initHeader from './views/Header';

import CurrencySelector from './views/CurrencySelector';
import LanguageSelector from './views/LanguageSelector';
import NewsletterSignUp from 'ofs/components/mailing/NewsletterSignUp';
import WelcomeVoucher from './views/WelcomeVoucher';


export default class EntryPoint {
  getStores() {
    return {
      DateStore: new DateStore(this.options.dates),
      GuestStore: new GuestStore(this.options.guests),
      EnquiryStore: new EnquiryStore(
        Immutable.fromJS(this.options.enquiry) || Immutable.Map()
      ),
      LayerStore: new LayerStore(),
      TrackingStore: new TrackingStore(),
      LanguageStore: new LanguageStore(this.options.language)
    };
  }

  getActions() {
    return actions;
  }

  constructor(options) {
    this.options = Object.freeze(options || {});
    this.flux = typeof window !== 'undefined' && window.ofsFlux ? window.ofsFlux : new Flux(this.getStores(), this.getActions());
    this.keyboard = new Keyboard();

    if (typeof window !== 'undefined') {
      window.ofsFlux = this.flux; // Legacy support
    }
  }

  renderToDocument(document) {
    attachFastClick(document.body);

    React.render(
      <LayerStack flux={this.flux} keyboard={this.keyboard} />,
      document.getElementById('layer-stack')
    );

    var languageWarningEl = document.getElementById('language-warning');

    if (languageWarningEl) {
      React.render(
        <LanguageWarning flux={this.flux} />,
        languageWarningEl
      );
    }

    legacy.initComponents($(document)); // Legacy components

    var currencySelectorEl = document.getElementById('currency-selector');
    if (currencySelectorEl) {
      React.render(
        <CurrencySelector flux={this.flux} />,
        currencySelectorEl
      );
    }

    var languageSelectorEl = document.getElementById('language-selector');
    if (languageSelectorEl) {
      React.render(
        <LanguageSelector flux={this.flux} />,
        languageSelectorEl
      );
    }

    var mailingFormEl = document.getElementById('mailing-form');
    if (mailingFormEl) {
      React.render(
        <NewsletterSignUp source="footer" />,
        mailingFormEl
      );
    }

    // init header
    if ($('.-js--legacy-header').length) {
      // legacy header
      initLegacyHeader(this.flux);
    } else {
      initHeader(this.flux);
    }

    var $pageContainer = $('.ofs-PageContainer');
    var pageContainerWidth = $pageContainer.width();

    // refresh width on resize
    $(window).on('resize', () => pageContainerWidth = $pageContainer.width());

    $('#mobile-menu-toggle').on('click', function(event) {
      event.preventDefault();
      var $body = $('body');

      if ($body.css('position') !== 'fixed') {
        $body.css('position', 'fixed');
      } else {
        $body.css('position', 'static');
      }

      if (parseInt($pageContainer.css('width')) === pageContainerWidth) {
        // reset width
        $pageContainer.css('width', '100%');
      } else {
        $pageContainer.css('width', pageContainerWidth);
      }

      $('.ofs-Flyout').toggleClass('ofs-Flyout--is-visible');
      $pageContainer.toggleClass('ofs-PageContainer--offset');
    });

    // welcome voucher
    const welcomeVoucher = document.getElementById('welcome-voucher');

    if (welcomeVoucher && pageContainerWidth > 640 && document.location.href.search('no_welcome_voucher') == -1) {
      setTimeout(() => {
        this.flux.actions.layers.addModal(<WelcomeVoucher popupAd={true}/>);
      }, 3000);
      Cookies.set('welcome_voucher', true, {'path': '/'});
    }
  }

  renderToString() {

  }

  render(document) {
    if (document) {
      this.renderToDocument(document);
    } else {
      return this.renderToString();
    }
  }
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/entry.jsx
 **/